import { Renderer2, Component, Inject } from '@angular/core';
import { environment } from '../environments/environment';
import { Router, NavigationEnd } from '@angular/router';
import { AuthService } from './shared/auth/auth.service';
import { DOCUMENT } from "@angular/platform-browser";

declare let gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})


export class AppComponent {
  title = 'app works!';
  group;


  constructor(@Inject(DOCUMENT) private document, public _authService: AuthService, public router: Router, private _renderer2: Renderer2) {

    let googlePropertyID = "UA-42233792-18";
    if (environment.baseSystem = "access") {
      googlePropertyID = "G-GBWT5MTWE3";
    } else {
      googlePropertyID = "UA-42233792-18";
    }
    let script = this._renderer2.createElement('script');
    script.type = "text/javascript";
    script.src = 'https://www.googletagmanager.com/gtag/js?id='+googlePropertyID;

    this._renderer2.appendChild(this.document.body, script);

    router.events.subscribe(s => {
      this._authService.refreshTokenNew();
      // console.log("Event router change detected ");

      if (s instanceof NavigationEnd) {

        gtag('config', googlePropertyID,
          {
            'page_path': s.urlAfterRedirects
          }

        );
      }


    });

    if (environment.baseSystem == "access") {
      this.document.getElementById('appcss').setAttribute('href', '/scss/app_access.css');
      this.document.getElementById('customcss').setAttribute('href', '/scss/custom_access.css');
      this.document.getElementById('profilecss').setAttribute('href', '/scss/profile_access.css');
      this.document.getElementById('headercss').setAttribute('href', '/scss/headers/header-v1_access.css');
      this.document.getElementById('appFavicon').setAttribute('href', '/assets/img/access_favicon.png');
    }

    if (this._authService.isAuthenticated()) {

      this.group = this._authService.getUserData().groupIds[0];
      if (this.group === 23575) {
        this.document.getElementById('appcss').setAttribute('href', '/scss/app_amcal.css');
        this.document.getElementById('customcss').setAttribute('href', '/scss/custom_amcal.css');
        this.document.getElementById('profilecss').setAttribute('href', '/scss/profile_amcal.css');
        this.document.getElementById('headercss').setAttribute('href', '/scss/headers/header-v1_amcal.css');
      }
      if (this.group === 23574) {
        this.document.getElementById('appcss').setAttribute('href', '/scss/app_guardian.css');
        this.document.getElementById('customcss').setAttribute('href', '/scss/custom_guardian.css');
        this.document.getElementById('profilecss').setAttribute('href', '/scss/profile_guardian.css');
        this.document.getElementById('headercss').setAttribute('href', '/scss/headers/header-v1_guardian.css');
      }
      if (this.group === 23573) {
        this.document.getElementById('appcss').setAttribute('href', '/scss/app_access.css');
        this.document.getElementById('customcss').setAttribute('href', '/scss/custom_access.css');
        this.document.getElementById('profilecss').setAttribute('href', '/scss/profile_access.css');
        this.document.getElementById('headercss').setAttribute('href', '/scss/headers/header-v1_access.css');
      }

    }

  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts